<div [ngClass]="loading ? 'select-none' : ''"
     class="border border-gray-200 rounded-lg w-full h-[123px] overflow-hidden">
  <div class="overflow-x-auto h-full">
    <div class="flex flex-row justify-between items-center px-8 py-4 min-w-max h-full">

    @if (checkType === 'MY_CHECK') {
      <!-- Prüflauf und myCheck -->
      <div class="flex flex-col justify-start items-start gap-2 flex-1 min-w-0">
        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">Prüflauf</p>
          @if (myCheckLink) {
            <a [appSkeletonLoading]="loading" [routerLink]="myCheckLink" [tooltip]="info1Tooltip"
               class="text-sm font-medium text-gray line-clamp-1 hover:text-green hover:underline transition-colors"
               skeletonWidth="w-[200px]">{{ info1 }}</a>
          } @else {
            <p [appSkeletonLoading]="loading" [tooltip]="info1Tooltip"
               class="text-sm font-medium text-gray line-clamp-1"
               skeletonWidth="w-[200px]">{{ info1 }}</p>
          }
        </div>

        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">myCheck</p>
          @if (rulesetLinks.length > 0) {
            <p [appSkeletonLoading]="loading" class="text-sm font-medium text-gray line-clamp-1"
               skeletonWidth="w-[200px]">
              @for (link of rulesetLinks; track link.id; let last = $last) {
                @if (link.routerLink) {
                  <a [routerLink]="link.routerLink"
                     class="hover:text-green hover:underline transition-colors">{{ link.name }}</a>
                } @else {
                  <!-- Zentral bereitgestellt: kein Editor-Link, sonst liesse sich die Vorlage
                       aus dem Bericht heraus ueberschreiben (die Uebersicht bietet hier
                       ebenfalls nur "Duplizieren" an). -->
                  <span>{{ link.name }}</span>
                }
                @if (!last) {
                  <span>, </span>
                }
              }
            </p>
          } @else {
            <p [appSkeletonLoading]="loading" class="text-sm font-medium text-gray line-clamp-1"
               skeletonWidth="w-[200px]">{{ info2 }}</p>
          }
        </div>
      </div>

      <!-- Prüfregeltyp und Prüfregeln -->
      <div class="flex flex-col justify-start items-start gap-2 flex-1 min-w-0">
        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">Prüfregeltyp</p>
          <p [appSkeletonLoading]="loading" class="text-sm font-medium text-gray line-clamp-1"
             skeletonWidth="w-[200px]">{{ ruleTypeLabel }}</p>
        </div>

        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">Prüfregeln</p>
          <p [appSkeletonLoading]="loading" class="text-sm font-medium text-gray line-clamp-1"
             skeletonWidth="w-[200px]">{{ rules }}</p>
        </div>
      </div>

      <!-- Datum und geprüfte Dateien -->
      <div class="flex flex-col justify-start items-start gap-2 flex-1 min-w-0">
        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">Datum</p>
          <p [appSkeletonLoading]="loading" class="text-sm font-medium text-gray line-clamp-1"
             skeletonWidth="w-[200px]">{{ date | date: 'dd.MM.y' }}
            - {{ date | date: 'HH:mm' }}</p>
        </div>

        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">{{ fileCount === 1 ? 'Geprüfte Datei' : 'Geprüfte Dateien' }}</p>
          <!-- [tooltip] nur im Ein-Datei-Fall binden: die TooltipDirective zeigt beim Hover immer eine
               Blase, auch bei leerem String - ein leeres [tooltip]="''" im Mehrdateien-Fall erzeugt also
               eine sichtbare, aber inhaltslose Tooltip-Blase statt gar keine anzuzeigen. -->
          @if (fileCount === 1) {
            <p [appSkeletonLoading]="loading" [tooltip]="fileName"
               class="text-sm font-medium text-gray line-clamp-1"
               skeletonWidth="w-[200px]">{{ fileName || fileCount }}</p>
          } @else {
            <p [appSkeletonLoading]="loading"
               class="text-sm font-medium text-gray line-clamp-1"
               skeletonWidth="w-[200px]">{{ fileCount }}</p>
          }
        </div>
      </div>

      <!-- Projekt und Prüfer -->
      <div class="flex flex-col justify-start items-start gap-2 flex-1 min-w-0">
        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">Projekt</p>
          <p [appSkeletonLoading]="loading" class="text-sm font-medium text-gray line-clamp-1"
             skeletonWidth="w-[200px]">{{ stateConfigService.selectedProject.name }}</p>
        </div>

        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">Prüfer*in</p>
          <p [appSkeletonLoading]="loading" class="text-sm font-medium text-gray line-clamp-1"
             skeletonWidth="w-[200px]">{{ checkerName }}</p>
        </div>
      </div>
    } @else {
      <!-- Leistungsbild und Phase -->
      <div class="flex flex-col justify-start items-start gap-2 flex-1 min-w-0">
        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">
            @switch (checkType) {
              @case ("HOAI") {
                Leistungsbild
              }
              @case ('LOI') {
                Dateigröße
              }
              @case ('BIM_BASE') {
                Dateigröße
              }
              @case ('QUALITY') {
                Prüfmodul
              }
            }
          </p>
          <p [appSkeletonLoading]="loading" class="text-sm font-medium text-gray line-clamp-1"
             skeletonWidth="w-[200px]">{{ info1 }}</p>
        </div>

        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">
            @switch (checkType) {
              @case ("HOAI") {
                Leistungsphase
              }
              @case ('LOI') {
                Datei
              }
              @case ('BIM_BASE') {
                Datei
              }
              @case ('QUALITY') {
                Anzahl Dateien
              }
            }
          </p>
          <p [appSkeletonLoading]="loading" class="text-sm font-medium text-gray line-clamp-1"
             skeletonWidth="w-[200px]">{{ info2 }}</p>
        </div>
      </div>

      <!-- Datum und Prüfregelmenge -->
      <div class="flex flex-col justify-start items-start gap-2 flex-1 min-w-0">
        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">Datum</p>
          <p [appSkeletonLoading]="loading" class="text-sm font-medium text-gray line-clamp-1"
             skeletonWidth="w-[200px]">{{ date | date: 'dd.MM.y' }}
            - {{ date | date: 'HH:mm' }}</p>
        </div>

        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">
            @switch (checkType) {
              @case ('LOI') {
                Prüfregelset
              }
              @default {
                Prüfregeln
              }
            }
          </p>
          <p [appSkeletonLoading]="loading" class="text-sm font-medium text-gray line-clamp-1"
             skeletonWidth="w-[200px]">{{ rules }}</p>
        </div>
      </div>

      <!-- Projekt und Prüfer -->
      <div class="flex flex-col justify-start items-start gap-2 flex-1 min-w-0">
        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">Projekt</p>
          <p [appSkeletonLoading]="loading" class="text-sm font-medium text-gray line-clamp-1"
             skeletonWidth="w-[200px]">{{ stateConfigService.selectedProject.name }}</p>
        </div>

        <div class="flex flex-col justify start items-start">
          <p class="text-xs text-gray-500 select-none">Prüfer*in</p>
          <p [appSkeletonLoading]="loading" class="text-sm font-medium text-gray line-clamp-1"
             skeletonWidth="w-[200px]">{{ checkerName }}</p>
        </div>
      </div>
    }

    <div class="flex flex-row justify-center items-center gap-4 rounded-lg">
      <!-- ...existing code... circle states and buttons -->
      @if (singleResult) {
        <!-- EIN Gesamtergebnis (#2317). Die drei Kreise zeigen eine Statusverteilung -- bei IDS
             gibt es die nicht, dort musste warning=0 und error=100-completed erfunden werden. -->
        <div class="w-[91px]"></div>
        <app-circle-state [compact]="true" [state]="singleResultState()"
                          [tooltip]="singleResultTooltip()"
                          [value]="singleResult.percent ?? 0"
                          class="w-[91px]"></app-circle-state>
        <div class="w-[91px]"></div>
      } @else {
      @switch (checkType) {
        @case ('LOI') {
          <div class="w-[91px]"></div>
          <app-circle-state [compact]="true" [state]="loading ? CircleState.LOAD : CircleState.GREEN"
                            [tooltip]="loading ? 'Lädt' : 'Erfüllt'"
                            [value]="isFinite(completedValue) ? Math.round(completedValue)  : 0"
                            class="w-[91px]"></app-circle-state>
          <div class="w-[91px]"></div>
        }
        @default {
          <app-circle-state [compact]="true" [state]="loading ? CircleState.LOAD : CircleState.GREEN"
                            [tooltip]="loading ? 'Lädt' : 'Erfüllt'"
                            [value]="isFinite(completedValue) ? Math.round(completedValue)  : 0"
                            class="w-[91px]"></app-circle-state>
          <app-circle-state [compact]="true" [state]="loading ? CircleState.LOAD : CircleState.YELLOW"
                            [tooltip]="loading ? 'Lädt' : 'Teilweise erfüllt'"
                            [value]="isFinite(warningValue) ? Math.round(warningValue) : 0"
                            class="w-[91px]"></app-circle-state>
          <app-circle-state [compact]="true" [state]="loading ? CircleState.LOAD : CircleState.RED"
                            [tooltip]="loading ? 'Lädt' : 'Nicht erfüllt'"
                            [value]="isFinite(errorValue) ? Math.round(errorValue) : 0"
                            class="w-[91px]"></app-circle-state>
        }
      }
      }
      @if (showActions) {
      @if (checkType === 'MY_CHECK') {
        <div class="flex flex-row justify-center items-center gap-4">
          <button (click)="downloadPressed()" [disabled]="!activateDownload" [tooltip]="'Bericht herunterladen'"
                  class="bg-white border border-gray-300 rounded-lg h-[38px] w-[40px] flex items-center justify-center text-gray hover:bg-gray-100 disabled:opacity-50 disabled:hover:bg-white">
            <fa-icon [icon]="faArrowDownToBracket"></fa-icon>
          </button>

          <button (click)="open.emit()" [disabled]="!activateOpen" [tooltip]="'Im Viewer öffnen'"
                  class="bg-white border border-gray-300 rounded-lg h-[38px] w-[40px] flex items-center justify-center text-gray hover:bg-gray-100 disabled:opacity-50 disabled:hover:bg-white">
            <fa-icon [icon]="faArrowUpRightFromSquare"></fa-icon>
          </button>

          <button (click)="showLogsPressed()" [tooltip]="'Logs anzeigen'"
                  class="bg-white border border-gray-300 rounded-lg h-[38px] w-[40px] flex items-center justify-center text-gray hover:bg-gray-100">
            <fa-icon [icon]="faClipboardList"></fa-icon>
          </button>
        </div>
      } @else {
        <div class="flex flex-col justify-center items-stretch gap-2">
          <bic-button (click)="downloadPressed()" [disabled]="!activateDownload" [fullWidth]="true" buttonType="white"
                      class="w-full" color="#FFF">
            Bericht
            <fa-icon [icon]="faArrowDownToBracket" iconLeft></fa-icon>
          </bic-button>

          <bic-button (click)="open.emit()" [disabled]="!activateOpen" [fullWidth]="true" buttonType="white"
                      class="w-full" color="#FFF">
            Viewer
            <fa-icon [icon]="faArrowUpRightFromSquare" iconLeft></fa-icon>
          </bic-button>
        </div>
      }
      }
    </div>


  </div>
  </div>

</div>

